'use client';

import {
	ButtonGroup,
	Card,
} from '@chakra-ui/react';

import { RegistrationForm } from '@/modules/authentication/presentation/forms';
import { RegistrationFormSchema, useRegistrationForm   } from '@/modules/authentication/view-model';
import type { RegistrationFormModel } from '@/modules/authentication/view-model';

import { Form } from '@packages/hook-form-wrapper';

export const RegistrationContainer = () => {
	const { execute } = useRegistrationForm();

	return (
		<Card.Root w="full">
			<Card.Header>
				<Card.Title textAlign="center" textStyle="h3">Please enter your name and information</Card.Title>
			</Card.Header>
			<Form.Provider<RegistrationFormModel> onSubmit={execute} schema={RegistrationFormSchema}>
				<Card.Body
					maxH="80vh"
					overflow="scroll"
					px="md"
					py="lg"
					scrollbar="hidden"
				>
					<RegistrationForm />
				</Card.Body>
				<Card.Footer as={ButtonGroup} justifyContent="space-between">
					<Form.SubmitButton size="lg" w="full">
						Register
					</Form.SubmitButton>
				</Card.Footer>
			</Form.Provider>
		</Card.Root>
	);
};
